import { render, staticRenderFns } from "./userAmtIOS.vue?vue&type=template&id=192a8c82&scoped=true&"
import script from "./userAmtIOS.vue?vue&type=script&lang=js&"
export * from "./userAmtIOS.vue?vue&type=script&lang=js&"
import style0 from "./userAmtIOS.vue?vue&type=style&index=0&id=192a8c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192a8c82",
  null
  
)

export default component.exports